/* Dati */
export const HostServer = 'http://51.77.214.41:3000';


/* DASCHBOARD */
export const DashboardRoot = `${HostServer}/dashboard`;
export const CountersRoot = `${HostServer}/counters`;

/* USER */
export const LoginAPI = `${HostServer}/auth/login`;
export const UserRoot = `${HostServer}/users`;
export const ResetPasswordRoot = `${HostServer}/auth/reset-password/send-code`;
export const ChangePasswordRoot = `${HostServer}/auth/reset-password/change-password`;

/* USER ROLE */
export const UserRoleRoot = `${HostServer}/roles`;
export const UserRolePermissionRoot = `${HostServer}/roles/permissions`;

/* VEHICLE */
export const VehiclesRoot = `${HostServer}/vehicles`;
export const VehicleTypeRoot = `${HostServer}/vehicleTypes`;

// FLEET
export const FleetRoot = `${HostServer}/fleets`;

/* TASK */
export const TaskRoot = `${HostServer}/tasks`;

/* TASK MODEL */
export const TaskModelRoot = `${HostServer}/taskModel`;

/* DEVICE */
export const DevicesRoot = `${HostServer}/devices`;
export const DevicesAvailableRoot = `${HostServer}/devices/available`;

/* DEALERSHIP */
export const DealersRoot = `${HostServer}/dealers`;

/* COMPANY */
export const CompanyRoot = `${HostServer}/companies`;

/* MAINTENANCE */
export const ServicesRoot = `${HostServer}/services`;

/* SERVICE PLAN */
export const ServicePlanRoot = `${HostServer}/servicePlans`;
export const ServicePlanConfigurationRoot = `${HostServer}/servicePlans/configuration`;

/* SERVICE PLAN MODEL */
export const ServicePlanModelRoot = `${HostServer}/servicePlanModel`;

/* METADATA */
export const MetadataRoot = `${HostServer}/metadata`;

/* NOTES */
export const NoteRoot = `${HostServer}/notes`;

/* LOG */
export const LogRoot = `${HostServer}/logs`;

/* NOTIFICATION */
// export const NotificationsWS = `ws://192.168.1.156:3051`;
export const NotificationRoot = `${HostServer}/notifications`;
